import React from 'react'
import { PowerMeterProviderContextProps } from './types'

export const PowerMeterProviderContext = React.createContext<PowerMeterProviderContextProps | undefined>(undefined)
